// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9c3bfe4f","453":"40748a1b","455":"a8e2dc39","977":"e8d17281"}[chunkId] + ".chunk.js";
};